
import { EnvironmentInterface } from './environment.interface';

export const environment: EnvironmentInterface = {
  baseUrl: 'https://backend.test.daguve.com',
  production: true,
  showTestLabel: true,
};
